export default {"src":"/_next/static/media/ling-process.10ad01b2.svg","height":529,"width":1440,"blurWidth":0,"blurHeight":0};